import { render, staticRenderFns } from "./NoEncontrado.vue?vue&type=template&id=035d555e&scoped=true&"
import script from "./NoEncontrado.vue?vue&type=script&lang=js&"
export * from "./NoEncontrado.vue?vue&type=script&lang=js&"
import style0 from "./NoEncontrado.vue?vue&type=style&index=0&id=035d555e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035d555e",
  null
  
)

export default component.exports